import { ResponsiveSunburst } from "@nivo/sunburst";
import React from "react";

export const SunburstGeneral = ({ sunbursProps = { data: { children: [], name: "data" }, id: "name", value: "count" } }) => {
	const props = {
		margin: { top: 10, right: 10, bottom: 10, left: 10 },
		cornerRadius: 2,
		colors: (parent, child) => {
			if (parent.data.color) {
				return parent.data.color;
			}
			return "#ccc";
		},
		childColor: (parent, child) => {
			if (child.data.color) {
				return child.data.color;
			}
			return "#ccc";
		},
		enableArcLabels: true,
		arcLabel: (e) => `${e.value}`,

		arcLabelsSkipAngle: 10,
		borderColor: "#000",
	};
	return <ResponsiveSunburst {...props} {...sunbursProps} />;
};
